import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import App from './App';
import registerServiceWorker from './registerServiceWorker';
import reduxStore from './services/reduxStore';
import './fonts/fonts.css';
import './index.css';

ReactDOM.render(
	<Provider store={ reduxStore }>
		<App />
	</Provider>,
	document.getElementById('root')
);

registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js